// extracted by mini-css-extract-plugin
export default {"base":"InventionsTable_base__XaA-w","missingData":"InventionsTable_missingData__R8hDM","dots":"InventionsTable_dots__I27eL","tooltip":"InventionsTable_tooltip__v0ofv"};